import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../login/loginSlice";
import { changeActive, changeAmount, changeDescription, changeTransactionDate, clearForm, isEditTransactionFormActive, selectEditTransactionFormAmount, selectEditTransactionFormDescription, selectEditTransactionFormTransactionDate, selectEditTransactionId } from "./editTransactionFormSlice";

import './EditTransactionForm.css';
import { changeConfirmingDeleteTransaction, changeConfirmingUpdateTransaction, deleteTransaction, removeTransaction, selectConfirmingDeleteTransaction, selectConfirmingUpdateTransaction, selectTransactions, updateTransaction, updatingTransaction } from "../transactionList/transactionsSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";

export default function EditTransactionForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const editTransactionFormIsActive = useSelector(isEditTransactionFormActive);
    const transactionId = useSelector(selectEditTransactionId);
    const description = useSelector(selectEditTransactionFormDescription);
    const transactionDate = useSelector(selectEditTransactionFormTransactionDate);
    const amount = useSelector(selectEditTransactionFormAmount);

    const transactionUpdating = useSelector(updatingTransaction);
    const confirmingUpdateTransaction = useSelector(selectConfirmingUpdateTransaction);

    const confirmingDeleteTransaction = useSelector(selectConfirmingDeleteTransaction);

    const transactions = useSelector(selectTransactions);

    const display = editTransactionFormIsActive ? "flex" : "none";

    const handleDescriptionChange = (event) => {
        dispatch(changeDescription(event.target.value));
    }

    const handleTransactionDateChange = (event) => {
        dispatch(changeTransactionDate(event.target.value));
    }

    const handleAmountChange = event => {
        dispatch(changeAmount(event.target.value));
    }

    const handleCancelEditClick = () => {
        dispatch(changeActive(false));
        dispatch(clearForm());
    }

    const handleDeleteButtonClick = (event) => {
        event.preventDefault();
        dispatch(changeConfirmingDeleteTransaction(true))
    }

    const handleConfirmDeleteClick = () => {
        dispatch(deleteTransaction({transactionId, token}))
        dispatch(changeActive(false));
        dispatch(removeTransaction(transactionId));
        dispatch(changeConfirmingDeleteTransaction(false));
    }

    const handleSaveClick = event => {
        event.preventDefault();
        dispatch(changeConfirmingUpdateTransaction(true));
    }

    const handleConfirmingSaveClick = event => {
        event.preventDefault();

        let transactionToUpdate = transactions.find(transaction => transaction.id === transactionId);
        transactionToUpdate = {
            ...transactionToUpdate,
            description: description,
            transactionDate: transactionDate,
            amount: amount
        }

        dispatch(updateTransaction({transaction: transactionToUpdate, token}))
        dispatch(changeConfirmingUpdateTransaction(false));
    }

    const handleConfirmCancelClick = () => {
        dispatch(changeConfirmingUpdateTransaction(false));
        dispatch(changeConfirmingDeleteTransaction(false));
    }

    return (
        <form className="form" style={{display, flexDirection: 'column'}}>
            <h3>Edit Transaction</h3>
            <label htmlFor="description">
                Description:
                <input value={description} onChange={handleDescriptionChange}></input>
            </label>
            <label htmlFor="transactionDate">
                Transaction Date:
                <input type="date" value={transactionDate} onChange={handleTransactionDateChange}></input>
            </label>
            <label>
                Amount:
                <input htmlFor="amount" value={amount} onChange={handleAmountChange}></input>
            </label>
            <div className="button-container">
                <button onClick={handleCancelEditClick} disabled={transactionUpdating}>Cancel</button>
                <button onClick={handleDeleteButtonClick} disabled={transactionUpdating}>Delete Transaction</button>
                <button onClick={handleSaveClick} disabled={transactionUpdating}>Save Changes</button>
            </div>
            {confirmingDeleteTransaction ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmDeleteClick} /> : ""}
            {confirmingUpdateTransaction ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmingSaveClick} /> : ""}
        </form>
    )
}